import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import RootReducer from './reducers/RootReducer'
// import riderReducer from "./reducers/rider"
let nodeEnv = 'production'

const composeEnhancers =
  (nodeEnv !== 'production' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose

// const rootReducer = combineReducers({
//     rider: riderReducer,
//     RootReducer
//   });

// export const store = createStore(RootReducer, composeEnhancers );
export const store = createStore(
  RootReducer,
  composeEnhancers(applyMiddleware(thunk)),
)
